function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Close");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Exports-Seven-Form",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Overlay",
  transform: "translate(-764.000000, -145.000000)"
}, React.createElement("g", {
  id: "Close",
  transform: "translate(764.000000, 145.000000)"
}, React.createElement("circle", {
  id: "closeIconCircle",
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#9ACB39"
}), React.createElement("g", {
  id: "closeIconCross",
  transform: "translate(17.606602, 16.606602) rotate(45.000000) translate(-17.606602, -16.606602) translate(10.106602, 9.106602)",
  fill: "#FFFFFF"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 6,
  y: 0,
  width: 3,
  height: 15
}), React.createElement("rect", {
  id: "Rectangle-Copy-2",
  transform: "translate(7.500000, 7.500000) rotate(90.000000) translate(-7.500000, -7.500000) ",
  x: 6,
  y: 0,
  width: 3,
  height: 15
})))));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "closeIcon",
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Close.20060ea3.svg";
export { ForwardRef as ReactComponent };